import styled from 'styled-components';
import { breakpoints } from '_constants/mediaOptions';

const Alert = styled.div.attrs({
    className: 'alert',
})`
    width: 450px;

    ${breakpoints.sm} {
        width: 350px;
    }

    h3 {
        font-family: Poppins;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #0a0a0a;
    }

    p {
        font-family: Poppins;
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        letter-spacing: 0em;
        text-align: left;
        color: #0A0A0A;
        opacity: 0.4;
    }
`;

export default Alert;
